export const checkOffersMeasuresHaveDiffs = (offers, measure) => offers.some((offer) => offer.measure !== measure);
